<template>
  <el-dialog
    v-model="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :width="dialogWidth"
    @close="handleClose"
  >
    <template #header>
      <div class="dialog-header">
        <span>{{ title }}</span>
      </div>
    </template>

    <div style="text-align: right">{{ message }}</div>
    <div style="text-align: right; color: red; margin-top: 12px">
      {{ resultMessage }}
    </div>
    <template #footer>
      <el-button @click="handleCancel" :disabled="waiting">بستن</el-button>
      <el-button
        type="primary"
        :loading="waiting"
        @click="handleConfirm"
        :disabled="waiting"
        >تأیید</el-button
      >
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps, onMounted } from "vue";

import socket from "@/services/socket";

const props = defineProps({
  modelValue: Boolean,
  title: String,
  message: String,
  type: String,
  activeDevice: Array,
  dialogData: Object,
});
const emit = defineEmits(["update:modelValue", "confirmed"]);

const visible = ref(props.modelValue);
const waiting = ref(false);
const resultMessage = ref(null);
let timeout = null;
const dialogWidth = ref("400px");
const updateDialogWidth = () => {
  dialogWidth.value = window.innerWidth <= 600 ? "98%" : "400px";
};
onMounted(() => {
  updateDialogWidth();
  window.addEventListener("resize", updateDialogWidth);
});

watch(
  () => props.modelValue,
  (val) => {
    visible.value = val;
  }
);
watch(visible, (val) => {
  emit("update:modelValue", val);
  resultMessage.value = null;
});

const handleClose = () => {
  if (!waiting.value) visible.value = false;
};

const handleCancel = () => {
  if (!waiting.value) visible.value = false;
};

const handleConfirm = () => {
  if (props.activeDevice.user_local_id == null) {
    resultMessage.value =
      "امکان اجرای دستور  بدون اثر انگشت ممکن نیست، لطفا به ثبت اثر انگشت اقدام فرمایید";
    return;
  }
  waiting.value = true;
  resultMessage.value = "";
  const sendData = {
    deviceID: props.activeDevice.device_id,
    pin: props.activeDevice.pin,
    code: props.activeDevice.code,
  };

  let topic;
  if (props.type === "motor") {
    topic = "motor/change/status";
    sendData.status = props.activeDevice.status_well == 1 ? 0 : 1;
    sendData.userLocalID = props.activeDevice.user_local_id;
  } else {
    topic = "program/delete";
    sendData.weekDay = props.dialogData.weekDay;
    sendData.startTime = props.dialogData.startTime;
    sendData.endTime = props.dialogData.endTime;
    sendData.userLocalID = props.dialogData.userLocalID;
  }

  socket.emit(topic, sendData);

  timeout = setTimeout(() => {
    resultMessage.value = "متاسفانه پاسخی از سمت دستگاه دریافت نشد.";
    waiting.value = false;
  }, 40000);

  socket.once("motor/status", (data) => {
    clearTimeout(timeout);
    if (data.status == 2) {
      resultMessage.value = "متاسفانه پاسخی از سمت دستگاه دریافت نشد.";
      waiting.value = false;
      return;
    }
    waiting.value = false;
    visible.value = false;
    emit("confirmed", data); // <=== این خط اضافه کن
  });
  socket.once("program/delete", (data) => {
    clearTimeout(timeout);
    if (data.status == 2) {
      resultMessage.value = "متاسفانه پاسخی از سمت دستگاه دریافت نشد.";
      waiting.value = false;
      return;
    }
    waiting.value = false;
    visible.value = false;
    emit("confirmed", data); // <=== این خط اضافه کن
  });
};
</script>

<style scoped>
.dialog-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: bold;
}
::v-deep(.el-dialog__body) {
  text-align: right !important;
}
::v-deep(.el-dialog__footer) {
  text-align: center !important;
}

.el-dialog__footer button {
  margin: 5px;
  width: 100px;
}
</style>
